export class XHtmlWriter {
	getHtml(fragment) {
		const parser = new DOMParser();
		const doc = parser.parseFromString('<root></root>', 'text/xml');

		const container = doc.children[0];
		container.appendChild(fragment);

		const xhtml = container.innerHTML;
		return xhtml.replaceAll(' xmlns="http://www.w3.org/1999/xhtml"', '');
	}
}
